import { Link } from '@tanstack/react-router';
import { useSetAtom } from 'jotai';
import { GlobeIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { walletModalOpenAtom } from '@/atoms/wallet-modal';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export function Header() {
  const { t, i18n } = useTranslation();
  const setIsOpen = useSetAtom(walletModalOpenAtom);

  const currentLanguage = i18n.language || 'en';
  const languageOptions = [
    { code: 'en', label: 'English' },
    { code: 'zh', label: '中文' },
  ];

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <header className="border-b bg-background/80 backdrop-blur-xl sticky top-0 z-50 px-4">
      <div className="container mx-auto flex h-16 items-center justify-between">
        <Link to="/">
          <img
            src="/images/logo-colored.png"
            alt="D9 Cross Chain Transfer"
            className="h-4 sm:h-6"
          />
        </Link>

        <div className="flex items-center gap-3 sm:gap-4">

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon" className="h-9 w-9">
                <GlobeIcon className="h-4 w-4" />
                <span className="sr-only">Switch language</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              {languageOptions.map((option) => (
                <DropdownMenuItem
                  key={option.code}
                  onClick={() => handleLanguageChange(option.code)}
                  className={currentLanguage === option.code ? 'bg-accent' : ''}
                >
                  {option.label}
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>

          <Button className="hidden sm:block" onClick={() => setIsOpen(true)}>
            {t('common.connectWallet')}
          </Button>
          <Button
            className="sm:hidden"
            size="sm"
            onClick={() => setIsOpen(true)}
          >
            {t('common.connect')}
          </Button>
        </div>
      </div>
    </header>
  );
}
